/* eslint-disable array-callback-return */
import React, { useState } from 'react';

import styles from './aboutContent.scss';

const PaidHitAvailabilityContent = (props) => (
    <div className={`${styles.value}`}>
        <span className="text-capitalize">{props.day}s</span>
        <div className={`${styles.bold} text-line-break mt8`}>
            {props.availability}
        </div>
    </div>
);

const PaidHitAvailability = (props) => {
    const {
        paidHitAvailability,
        className,
    } = props;

    const [showCompletePaidHitAvailability, setShowCompletePaidHitAvailability] = useState(false);

    const defaultListItemsCount = 2;
    const toShowPaidHitAvailability = paidHitAvailability ? paidHitAvailability.filter(a => a.isAvailable) : [];

    return (
        <>
            <div className="d-none d-md-block">
                {toShowPaidHitAvailability.length > 0 && (
                    <>
                        <h6 className="text-semi mt48">Paid Hit Availability</h6>
                        <div className={`${styles.about}`}>
                            {toShowPaidHitAvailability.map((data, i) => {
                                return (
                                    <PaidHitAvailabilityContent
                                        key={`availability-item-${i}`}
                                        {...data}
                                    />
                                );
                            })}
                        </div>
                    </>
                )}
            </div>
            <div className="d-md-none">
                {toShowPaidHitAvailability.length > 0 && (
                    <>
                        <h6 className="text-semi mt48">Paid Hit Availability</h6>
                        <div className={`${styles.about} ${className || ''}`}>
                            {toShowPaidHitAvailability.map((data, i) => {
                                if (i < defaultListItemsCount || showCompletePaidHitAvailability) {
                                    return (
                                        <PaidHitAvailabilityContent
                                            key={`availability-item-${i}`}
                                            {...data}
                                        />
                                    );
                                }
                            })}
                            {toShowPaidHitAvailability.length >= defaultListItemsCount && (
                                <div
                                    className={`${styles.value}`}
                                >
                                    <span
                                        className={`cursor-pointer text-teal`}
                                        onClick={() => {
                                            setShowCompletePaidHitAvailability(!showCompletePaidHitAvailability);
                                        }}
                                    >
                                        {showCompletePaidHitAvailability ? 'Show less' : 'Show more'}
                                    </span>
                                </div>
                            )}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default PaidHitAvailability;
